import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ContainerStyle } from './style'

const Container = props => {
    const { children, size, paddingTop = true } = props

    const className = classNames(
        ContainerStyle[size],
        paddingTop ? 'pt-14' : null
    )

    return <div className={className}>{children}</div>
}

Container.propTypes = {
    children: PropTypes.any,
    size: PropTypes.string,
    paddingTop: PropTypes.bool,
}

export default Container
